import { alpha } from '@mui/material/styles';
import { Stack, Text } from 'components/ui';
import { AuthSelectionList } from 'pages/Auth/components';
import { SIGN_IN_PRODUCT_SELECTION_PROMPT } from 'pages/Auth/SignIn/SignIn.constants';
import type { SignInProductSelectionStepProps } from './SignInProductSelectionStep.types';

const SignInProductSelectionStep = ({ loadingValue = null, onSelect, options }: SignInProductSelectionStepProps) => (
  <Stack spacing={2.5}>
    <Text
      sx={{
        color: theme => alpha(theme.palette.common.black, 0.75),
        fontSize: 16,
        fontWeight: 400,
        lineHeight: '24px',
      }}
      variant="body1"
    >
      {SIGN_IN_PRODUCT_SELECTION_PROMPT}
    </Text>
    <AuthSelectionList loadingValue={loadingValue} onSelect={onSelect} options={options} />
  </Stack>
);

export default SignInProductSelectionStep;
